"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSwapState = void 0;
exports.defaultSwapState = {
    sourceNetwork: "",
    targetNetwork: "",
    isSwapped: false,
    isSwapping: false,
    swapModalShow: false,
    transactionId: "",
    status: "",
};
//# sourceMappingURL=WalletSwapInterface.js.map